import { replace } from 'react-router-redux';

import { currentUser } from 'Actions/ContextInfoActions';

import { receiveGlobalMeta } from 'Actions/MetaActions';
import { setLastGlobalAction, setGlobalNotification, getFetchConfig, backInHistory } from 'Actions/GlobalMetaActions';
import { getLoadingBehavior, shouldNotUpdateState, updatePagesResult, fetchSuccess } from 'Actions/InfiniteScrollActions';
import { mapOnlineUsersLoadingBehaviour, getPageSize, getLandingPage } from 'Actions/UserSettingsActions';
import { responseNormalizer, updateUstate } from 'Actions/responseNormalizer';

import {
	fetchOnlineUsers,
	receiveOnlineUsers,
	resetOnlineUsers
} from 'Common/actions/OnlineUsersActions';

export * from 'Common/actions/OnlineUsersActions';

export const whoIsOnline = (pageNum,forceRefresh) => {

	return (dispatch,getState) => {

		const page = parseInt(pageNum),
			onlineRequest = {
				page,
				forceRefresh
			},
			loadingBehavior = getLoadingBehavior(getState, null, "onlineUsers", page, forceRefresh);

		if ( shouldNotUpdateState(getState, onlineRequest) ) {
			dispatch(updatePagesResult(pageNum||1));
			setLastGlobalAction('onlineUsers',onlineRequest);
			return null;
		}

		dispatch( fetchOnlineUsers(loadingBehavior) );

		const uid = dispatch( currentUser() ).id,
			state = getState(),
			page_size = dispatch( getPageSize() ),
			url = state.topifyPresets.forumSite.url + `?v=3.0&ajax=1&uid=${uid}&req=online`,
			config = dispatch( getFetchConfig( true ) );

		let lb = mapOnlineUsersLoadingBehaviour( state.ui.userSettings.onlineUsersLoadingBehavior );

		return fetch(`${url}&pagesize=${page_size}&page=${page}&lb=${ lb }`, config)
			.then( response => {
				if( !response.ok ) {
					try {
						response.json().then( ( json ) => {
							setGlobalNotification( dispatch, json, response );
						} ).catch( () => {
							setGlobalNotification( dispatch, {}, response );
						} );
					} catch( e ) {
						setGlobalNotification( dispatch, {}, response );
					}

					// If we have a non authorized let's redirect to landing page
					if( response.status === 401 ) {
						let landingPage = dispatch( getLandingPage() );
						dispatch( replace( landingPage ) );
					} else {
						dispatch( backInHistory() );
					}

				} else {
					return response.json();
				}
			})
			.then( json => {
				if ( !json ) { return; }

				let other = Object.assign( {}, { page: pageNum || 1 }, json.online ? json.online.meta : {} );

				let result = responseNormalizer( json, pageNum, other );

				dispatch( updateUstate( json, result ) );

				dispatch( receiveGlobalMeta(json.online.meta, "Who is Online") );
				dispatch( fetchSuccess(null, "onlineUsers", page, json.online.meta.totalPages, loadingBehavior));
				dispatch( receiveOnlineUsers( result, loadingBehavior ) )
			})
			.then(() => {
				setLastGlobalAction('onlineUsers',onlineRequest);
			})
			.catch( (error) => {
				setGlobalNotification( dispatch, {}, error );
			});
	};
};


// WEBPACK FOOTER //
// ./src/actions/OnlineUsersActions.js